module.exports = __webpack_public_path__ + "static/media/frp-app-image5.c80efc2b.png";